import { render } from "./ClimateTheRegion.vue?vue&type=template&id=e1ed5be4"
import script from "./ClimateTheRegion.vue?vue&type=script&lang=js"
export * from "./ClimateTheRegion.vue?vue&type=script&lang=js"

import "./ClimateTheRegion.vue?vue&type=style&index=0&id=e1ed5be4&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__